import type { FaireThemeEntity } from "../../entity_types/theme";

export const gold_luxe_for_less: FaireThemeEntity = {
  token: "gold-luxe-for-less",
  type: "theme",
  name: "Gold Luxe for Less",
  description: "High-quality 18K gold-plated jewelry that looks expensive but stays under a $10 wholesale anchor. Perfect for quick impulse buys at your beauty lounge checkout.",
  teaser: "K&K Visage Beauty Lounge has a strong history of ordering affordable, high-quality jewelry. These pieces allow for high margins while maintaining the premium aesthetic your customers expect.",
  detail: "The additional_context payload highlights 14 jewelry pieces, such as the Two-Tone Interlocking Ring and CZ Square Thin Ring, all of which fall below the $10.00 wholesale price anchor.",
  bgColor: "#FFD4D4",
  tileBgColor: "#6b6337",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_2q3tb6fmej",
    "p_vh9khkyckq",
    "p_hr2c2qxn5f",
    "p_85zuvdfqvw",
    "p_hccj8fkgxg",
    "p_pdvfyz7trd",
    "p_nrg5hxcuy3",
    "p_495zgeetkv",
    "p_bnj5c5gxgy",
    "p_ut3tbs6mrw",
    "p_jhcrb92fnq",
    "p_bagjhpjgk4",
    "p_ar6ja253qt",
    "p_uavgd4t79v",
    "p_s5kj5vxsjg",
    "p_ykcapkuvqq",
    "p_5gefr7p29d",
    "p_mrdc3wmdh2",
    "p_7aj8n8fwkr",
    "p_9pm84vbjg7",
    "p_ufjavmwa64",
    "p_zbfwgazcex",
    "p_ea35egy4z5",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
